import type { TSerializedWidget } from 'src/entities/workspace/types';
import { parseWellCorrelationWidgetInternalState } from 'src/pages/dashboard/features/well-correlation-widget/parseWellCorrelationWidget';
import type { WellCorrelationWidgetEntity } from 'src/pages/dashboard/features/well-correlation-widget/WellCorrelationWidget.entity';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function wellCorrelationApplyChanges(
  widget: WellCorrelationWidgetEntity,
  changes: TSerializedWidget,
  index: number,
) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseWellCorrelationWidgetInternalState(changes.internalState);

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
